import { memo } from "react";
import { ModalBox } from "src/components";
import { IllustratedModalContent } from "src/components/InnerModals";
import { PopupProps } from "src/components/Popup";
import { NavigationIllustration } from "src/images";

interface RegionUnsupportedModalProps extends Omit<PopupProps, "children"> {
  onComplete?: () => void;
  region?: string;
}

const RegionUnsupportedModal = ({ region, onComplete, ...props }: RegionUnsupportedModalProps) => (
  <ModalBox width={480} {...props}>
    <IllustratedModalContent
      actions={[
        {
          type: "primary",
          text: "Go back to fraction.com",
          action: onComplete,
        },
      ]}
      header="Fraction isn't available in your area"
      text="Unfortunately, Fraction isn't able to serve your area."
      image={<NavigationIllustration width={328} height={258} />}
    />
  </ModalBox>
);

export default memo(RegionUnsupportedModal);
